import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantTaskSharedService } from '../../services/wealthlane-award-services';

const useGetUpcomingEvents = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      id: number;
      title: string | null | undefined;
      type: string | null | undefined;
      sub: string;
      date: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const upcomingEvents = useQuery(
    ['getUpcomingEvents'],
    async () => {
      return await handleRequest(
        ParticipantTaskSharedService.getApiAwardApiAppParticipantTaskUpComingEvents()
      );
    },
    {
      select: (data) => {
        return data?.map((item, index: number) => {
          return {
            id: index,
            title: item.name,
            type: item.type,
            sub: `${item.units != null ? item.units : 'unknown'} units will be vested`,
            date: item.eventDate,
          };
        });
      },
    }
  );
  return upcomingEvents;
};

export default useGetUpcomingEvents;
